export const SCHOUW_HERPLAN_REDENEN = [
  'Klant onbereikbaar',
  'Klant niet gereed',
  'Klant niet aanwezig',
  'Afkeur op basis van foto’s',
  'Tracé niet vrij of onveilig',
  'Afmelding of verplaatsing op verzoek klant',
  'Werkmap onjuist of niet aangeleverd',
] as const

export const SCHOUW_CANCEL_REDENEN = [
  'Schouw wordt uitgevoerd in hoofdleidingproces',
  'Schouw is gelijktijdig uitgevoerd met een ander project',
] as const

export const BODEM_PAUSE_REDENEN = [
  'Combi schetsontwerp incompleet',
  'Informatie initiatiefnemer incompleet',
  'Netbeheerder ontwerp incompleet',
  'Sanering nodig',
]

export const NETCHECK_PAUSE_REDENEN = ['Geen vermogen beschikbaar']

export const GROUPED_PAUSE_REDENEN = [
  ...BODEM_PAUSE_REDENEN.map((reden) => ({ group: 'Bodem', label: reden })),
  ...NETCHECK_PAUSE_REDENEN.map((reden) => ({
    group: 'Netcheck',
    label: reden,
  })),
]
